import React, { useCallback, useEffect, useState } from 'react';

import { SelectButton } from '@pkg/components';
import { useAppSelector } from '@pkg/hooks';

import { ArtifactType } from '@app/client/common/structs/nft/artifacts';
import { artifactDisplayMetadata } from '@app/store/selectors/artifacts/artifacts-metadata';
import { combinedRoseSelector } from '@app/store/selectors/artifacts/celestial-roses';

import css from './MintTile.module.css';

interface MintTileProps {
    artifactType: ArtifactType;
    onSelect?: (selectedId?: string, selectedArtifactType?: ArtifactType) => void;
    hideButton?: boolean;
    isDisplay?: boolean;
    artifactId?: string;
    selected?: boolean;
    tokenId?: string;
    minted?: boolean;
    selectable?: boolean;
}

export function MintTile({
    artifactType,
    artifactId,
    minted,
    onSelect = () => null,
    hideButton = false,
    isDisplay = false,
    selected = false,
    selectable = false,
}: MintTileProps) {
    const artifactTypeDisplayItems = useAppSelector(artifactDisplayMetadata);
    const celestialRoseDisplayItems = useAppSelector(combinedRoseSelector);

    const [backgroundImage, setBackgroundImage] = useState<string>();

    useEffect(() => {
        if (artifactType === ArtifactType.CelestialRose) {
            const roseBg = celestialRoseDisplayItems.find((rose) => rose.id === artifactId)?.thumbnail_image;
            setBackgroundImage(`url(${roseBg})`);
        } else {
            const image = artifactTypeDisplayItems[artifactType]?.thumbnail_image;
            setBackgroundImage(`url(${image})`);
        }
    }, [artifactType, artifactId, celestialRoseDisplayItems, artifactTypeDisplayItems]);

    const handleClick = useCallback(() => {
        if (isDisplay) return;
        onSelect(artifactId, artifactType);
    }, [isDisplay, artifactId, artifactType, onSelect]);

    let classes = `${css.wrapper} ${css[artifactType]}`;
    if (minted) classes += ` ${css.minted}`;
    if (selected) classes += ` ${css.checked}`;
    if (isDisplay) classes += ` ${css.display}`;
    if (selectable) classes += ` ${css.selectable}`;

    return (
        <div className={classes} onClick={handleClick}>
            <div className={css.border}>
                {minted && (
                    <div className={css.nftInfo}>
                        <div className={css.title}>
                            View on
                            <br />
                            OpenSea
                        </div>
                        {/*todo add back when sorted*/}
                        {/*{tokenId && <div className={css.tokenId}>{`#${tokenId}`}</div>}*/}
                    </div>
                )}
                <div className={`${css.image}`} style={{ backgroundImage: backgroundImage }} />
                {!hideButton && <SelectButton className={css.select} checked={selected} minted={minted} />}
            </div>
        </div>
    );
}
